import React from 'react'
import PropTypes from 'prop-types'
import { GivingPageTemplate } from '../../templates/giving-page'

const GivingPagePreview = ({ entry, getAsset }) => {
  const data = entry.getIn(['data']).toJS()

  if (data) {
    return (
      <div>
        <GivingPageTemplate
          backgroundimage={getAsset(data.backgroundimage)}
        />
      </div>
    )
  } else {
    return <div>Loading...</div>
  }
}

GivingPagePreview.propTypes = {
  entry: PropTypes.shape({
    getIn: PropTypes.func,
  }),
  getAsset: PropTypes.func,
}

export default GivingPagePreview
